<template>
    <bottom-sheet v-model="shows" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <vertical-form-table v-bind="{ items }">
                    <template slot="계약서 서식" v-if="!value.isSigned">
                        <worker-form-page v-for="page in this.value.pages" :key="page.page" :value="{ ...value, page}"/>
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="shows = false"><span>확인</span></v-btn>
            </div>
            <!-- <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition> -->
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import WorkerFormPage from '../../../worker/form/worker-form-page.vue';

const items = [
    {
        key: "",
        term: "계약서 서식",
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        WorkerFormPage
    },
    props: {
        value: { type: Object, default: ()=>({}) }
    },
    data: () => ({
        // loading: false,
        items,
        shows: false,
        attrs_input,
    }),
};
</script>

<style lang="scss" scoped>
</style>
